const ResetpasswordEndpoints = {
    resetPassword(reqData: any) {
      return {
        url: "auth/user/resetPassword",
        data: reqData["reqBody"],
        headers: reqData["headers"],
      };
    }
  };
  export default ResetpasswordEndpoints;